import { FeatureSwitchInfo, SystemFlowInfo } from '@if/core/types'
import { apiClient } from '@src/services/http-common'
import { useQuery } from '@tanstack/react-query'

/* Section API React query hooks */

const SCOPE_SYSTEM_FLOW_SWITCHES = 'system-flow-switches'

const keysFactory = {
  systemFlowSwitches: () => [SCOPE_SYSTEM_FLOW_SWITCHES] as const,
}

export const fetchFeatureSwitches = async (): Promise<FeatureSwitchInfo> => {
  const response = await apiClient.get<FeatureSwitchInfo>('/FeatureSwitch')
  return response.data
}

const getSystemFlowSwitch = async () => {
  const response = await apiClient.get<SystemFlowInfo>('/SystemFlowSwitch')
  return response.data
}

const MIN_FLOW_REFRESH_MS = 60_000

const nextRefreshDelay = (next: Date | string | null | undefined): number | false =>
  next ? Math.max(new Date(next).getTime() - Date.now(), MIN_FLOW_REFRESH_MS) : false

export function useGetSystemFlowSwitch() {
  return useQuery({
    queryKey: keysFactory.systemFlowSwitches(),
    queryFn: getSystemFlowSwitch,
    refetchInterval: (query) => nextRefreshDelay(query.state.data?.nextRefreshDate),
  })
}
